import { Modal } from '../../../components/common/Modal';
import { useLanguage } from '../../../features/language/useLanguage';

interface UnlinkArtisanProfileModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isUnlinking: boolean;
  canUnlink: boolean;
}

/**
 * Confirmation dialog for detaching a linked Artisan roast profile from a work order.
 * Presentational only — the caller owns the async unlink via `onConfirm`.
 */
export function UnlinkArtisanProfileModal({
  isOpen,
  onClose,
  onConfirm,
  isUnlinking,
  canUnlink,
}: UnlinkArtisanProfileModalProps) {
  const { t } = useLanguage();

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        if (isUnlinking) return;
        onClose();
      }}
      title={t('workOrders.form.unlinkModal.title')}
      maxWidth="md"
    >
      <div className="space-y-4">
        <p className="text-sm text-gray-600">
          {t('workOrders.form.unlinkModal.message')}
        </p>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={isUnlinking}
            className="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50 disabled:opacity-50"
          >
            {t('workOrders.form.unlinkModal.no')}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isUnlinking || !canUnlink}
            className="inline-flex items-center rounded-md border border-transparent bg-red-600 px-3 py-2 text-sm font-semibold text-white hover:bg-red-700 disabled:opacity-50"
          >
            {isUnlinking ? t('workOrders.form.unlinkModal.unlinking') : t('workOrders.form.unlinkModal.yesUnlink')}
          </button>
        </div>
      </div>
    </Modal>
  );
}
